export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-zoom/src/constant.js
// module id = g9j3
// module chunks = 0